/** @format */

import { Component, Input } from '@angular/core';

import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { ProductAnalyticsService } from '@shared/data-access/analytics';

@Component({
	selector: 'pdp-custom-components-customize-product-button',
	templateUrl: './customize-product-button.component.html',
	styleUrl: './customize-product-button.component.scss',
	imports: [HmfButtonComponent]
})
export class CustomizeProductButtonComponent {
	@Input() customSeoUrl: string;

	constructor(private analyticsService: ProductAnalyticsService) {}
	public registerAnalytics() {
		// Set the Analytics event type
		this.analyticsService.setType('event', 'CustomizeThisClubButtonClicked');

		// Trigger the Analytics update
		this.analyticsService.triggerAnalyticsEvent('reporting:update');
	}
}
